module.exports = __webpack_public_path__ + "img/home13.ee449139.jpg";